import React ,{useContext, useEffect, useState} from "react";
import { Button , InputNumber , Table  , Row , Col , Tooltip , Typography,Modal, message, Switch, Radio, Checkbox } from "antd";
import { checkActionAllowed, isValidString , getArrayfromString, isValidArray, isValid, isValidNumber, isValidArrayWithValues  } from "../../utils/utilities";
import { ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL, UPDATE_DP_FOR_TRIP } from './../../utils/constant';
import './edit-fare.style.scss';
import { getAPIDateFormat, getFormatedDate } from './../../utils/date.utils';
import { getRoutesWithFareJson ,updateScheduleTripFare, updateTripRoutesFareType } from './edit-fare.module';
import moment from "moment";
import {
    ArrowDownOutlined,
    CheckOutlined,
    PlusOutlined,
    MinusOutlined,
    CopyOutlined,
    FireOutlined,
    CalendarOutlined
   } from '@ant-design/icons';
import { loadingAction } from './../../actions/loading-actions';
import { useDispatch } from "react-redux";

import { OriginDestionationFilter } from "../common-components/origin-destination-filter/origin-destination-filter.component";
import { DeviceContext } from "../device-provider/device-provider";
import ZoomComponent from './../custom-components/zoom-component/zoom.component';
import { getViacitiesDetails, updateTripDynamicPricing } from "../../actions/admin.action";
import { roundNumber } from "../../utils/math.utils";
import { DynamicPriceBtn } from "./dynamic-price.component";

const {
    Text 
} = Typography;

let plusBtn='plus',minusBtn='minus';

// @license lucide-static v1.21.0 - ISC
const LayersIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z" />
        <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
        <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
    </svg>
);

const FARE_TYPE_SEGMENT_GROUP_STYLE = {
    display: 'inline-flex',
    background: '#eceef1',
    borderRadius: 12,
    padding: 4,
    gap: 4,
};

const FARE_TYPE_SEGMENT_BASE_STYLE = {
    border: 'none',
    background: 'transparent',
    borderRadius: 9,
    padding: '6px 18px',
    minWidth: 90,
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 1,
    gap: 6,
};

const FARE_TYPE_SEGMENT_IDLE_STYLE = { ...FARE_TYPE_SEGMENT_BASE_STYLE, color: '#6b7280' };

const FARE_TYPE_SEGMENT_REGULAR_STYLE = {
    ...FARE_TYPE_SEGMENT_BASE_STYLE,
    background: '#ffffff',
    color: '#1f2937',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
};

const FARE_TYPE_SEGMENT_PEAK_STYLE = {
    ...FARE_TYPE_SEGMENT_BASE_STYLE,
    background: '#d6a417',
    color: '#ffffff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
};


export const EditFareComponent = (props) => {

    const{
        travelDate,
        scheduleId,
        seatGroupIds,
        selectedBus,
        onFareUpdateSuccess,
        tripRouteId,
        supportedFare,
        onCancel,
        selectedDates,
        showGetPriceButton=false,
        tripDynamicPricing,
        onGetPriceClick=()=>{},
        showTravelDate=true,
        clientSideCheck=false,
        renderAboveTable=null
    }=props;

    const [routes, setRoutes] = useState([]);
    const [filteredRoutes, setFilteredRoutes] = useState([]);
    const [origins, setOrigins] = useState([]);
    const [destinations, setDestinations] = useState([]);
    const [originsFiltered, setOriginsFiltered] = useState([]);
    const [destinationsFiltered, setDestinationsFiltered] = useState([]);
    const [value, setValue] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [btnType, setBtnType] = useState(null);
    const [errorHandle, setErrorHandle] = useState(null);
    const [fareUpdateType, setFareUpdateType] = useState('amount');
    const [defaultFare, setDefaultFare] = useState(false);
    const [activeColumn, setActiveColumn] = useState(null);
    const [canShowDynamicPricing, setCanShowDynamicPricing] = useState(false);
    const [changeSeatSpecificFare, setChangeSeatSpecificFare] = useState(true);
    const [defaultFareType, setDefaultFareType] = useState('REGULAR');

    const dispatch = useDispatch();

    const {
        isMobile
    }=useContext(DeviceContext);

    const dynamicPricingEnabled = global.dynamicPricingEnabled;

    const setLoading = (value)=>{
        dispatch(loadingAction(value));
    }

    useEffect(()=>{
        showModal();
    },[travelDate])

    useEffect(()=>{
        setCanShowDynamicPricing(checkActionAllowed(UPDATE_DP_FOR_TRIP));
    },[]);

    const fetchViaCitiesDetails = (defaultEditFare=false, fareTypeOverride=null)=>{
        setLoading(true);
        let fareTypeToUse = fareTypeOverride || defaultFareType;
        getViacitiesDetails(scheduleId,moment(travelDate),(data)=>{
            let {formatedData,filteredOrigins,filteredDestinations} = getRoutesWithFareJson(data,seatGroupIds,defaultEditFare,fareTypeToUse);
            setOrigins(filteredOrigins);
            setDestinations(filteredDestinations);
            setRoutes(formatedData);
            setFilteredRoutes(formatedData);
            setLoading(false);
        },()=>{},0,defaultEditFare);
    }
    
    const showModal = () => {
        if(isValid(travelDate)){
            setLoading(true);
            fetchViaCitiesDetails(false);
        }
    };

    const onOriginChange =(values)=>{
        let formatedData = [];
        setOriginsFiltered(values);
        routes.forEach(element => {
            if((values.indexOf(element.origin) !== -1 || values.length === 0) && (destinationsFiltered.length === 0 || destinationsFiltered.indexOf(element.destination) !== -1)){
                formatedData.push(element);
            }
        });
        setFilteredRoutes(formatedData);
    }

    const onDestionationChange =(values)=>{
        let formatedData = [];
        setDestinationsFiltered(values);
        routes.forEach(element => {
            if((values.indexOf(element.destination) !== -1 || values.length === 0) && (originsFiltered.length === 0 || originsFiltered.indexOf(element.origin) !== -1)){
                formatedData.push(element);
            }
        });
        setFilteredRoutes(formatedData);
    }

    const handleOk = () => {
    };

    const handleCancel = () => {
        onCancel();
    };

    function onChangeDynamicPricing(checked) {
        updateTripDynamicPricing(scheduleId, travelDate, checked, (data)=>{message.success(data)}, (err)=> {message.error(err)});
      }
      
      const formateErrorJsonObject = (fare,index,key,errFormat)=>{
        
        if(fare<100){
            if(!isValidArray(errFormat)){
                errFormat = {}
            }
            if(isValidArray(errFormat[index])){
                errFormat[index].push(key);
            }else{
                errFormat[index] = [key];
            }
            
        }
        return errFormat;
      }
 
    const handleUpdateFare=()=>{
        let errFormat = null;        
        let tempFilteredRoutes = [...filteredRoutes];
        
        if (!supportedFare) {
            tempFilteredRoutes.map((tempRoutes,index) => {
                let fareJson = tempRoutes.fare_json;
                if(isValidString(fareJson)){
                    fareJson = JSON.parse(fareJson);
                    let fare = -1;
                    for (const [key, value] of Object.entries(fareJson)) {
                        errFormat = formateErrorJsonObject(value,index,key,errFormat);
                        if (fare<0) {
                            fare = value;
                        }
                        else {
                            if (fare>value) {
                                fare = value;
                            }
                        }
                    }
                    if (fare>0) {
                        tempFilteredRoutes[index]['fare'] = fare;
                    }
                }
            })
        }else{
            tempFilteredRoutes.map((tempRoutes,index) => {
                errFormat = formateErrorJsonObject(tempRoutes.fare,index,'fare',errFormat);                
                let fareJson = tempRoutes.fare_json;
                if(isValidString(fareJson)){
                    fareJson = JSON.parse(fareJson);
                    for (const [key, value] of Object.entries(fareJson)) {
                        errFormat = formateErrorJsonObject(value,index,key,errFormat);
                    }
                }
            })
        }
        
        if(isValidArray(errFormat)){
            setErrorHandle(errFormat);            
            message.error("Minimum fare should be 100");
        }else{
            setErrorHandle(errFormat);
            setLoading(true);
            updateScheduleTripFare(
                tempFilteredRoutes,
                selectedDates,
                scheduleId,
                selectedBus,
                changeSeatSpecificFare,
                true,
                null,
                defaultFare,
                clientSideCheck,
                (msg)=>{
                message.success(msg);
                setLoading(false);
                handleOk();
                onFareUpdateSuccess(tripRouteId);
            },(emsg)=>{
                setLoading(false);
                handleOk();
                message.error(emsg);
            },
            defaultFare ? defaultFareType : 'REGULAR');
        }
    }

    const handleMarkFareType=(fareType)=>{
        if(!isValidArrayWithValues(selectedDates)){
            message.error("Please select date(s) to update fare");
            return;
        }
        setLoading(true);
        updateTripRoutesFareType(
            selectedDates,
            scheduleId,
            fareType,
            (msg)=>{
                message.success(msg);
                setLoading(false);
                onFareUpdateSuccess(tripRouteId);
            },(emsg)=>{
                setLoading(false);
                message.error(emsg);
            });
    }
    
    const getFare=(intialFare,addAmt)=>{
        if(isValid(addAmt)){
            if(btnType == plusBtn){
                if (fareUpdateType === 'percentage') {
                    return roundNumber(intialFare + (intialFare * addAmt / 100));
                }
                return roundNumber(intialFare+addAmt);
            }else{
                if (fareUpdateType === 'percentage') {
                    return roundNumber(intialFare - (intialFare * addAmt / 100));
                }
                return roundNumber(intialFare-addAmt);
            }

        }else{
            return intialFare;
        }
    }

    if(checkActionAllowed(ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL)){

        const copyFirstFareToAllRoutes =()=>{
            let fare = null , seatsArray = [] ,fareJson ={} , fareJsonString ='';

            for(var i=0;i<filteredRoutes.length;i++){
                    if(i == 0){
                        if(isValid(seatGroupIds)){
                            seatsArray=getArrayfromString(seatGroupIds);
                        }
                        if(supportedFare){
                            fare = filteredRoutes[0]['fare'];
                        }else{
                            let fareJson = filteredRoutes[0]['fare_json'];
                            let fareJsonObject=JSON.parse(fareJson);
                            fare = fareJsonObject[seatsArray[0]];
                        }
                        seatsArray.forEach((key)=>{
                                fareJson[key] = fare;
                        });
                        fareJsonString = JSON.stringify(fareJson);
                    }

                    filteredRoutes[i]["fare"] = fare;
                    filteredRoutes[i]["fare_json"] = fareJsonString;
                    filteredRoutes[i]["is_fare_edited"] = true;
                    
                }
            setFilteredRoutes([...filteredRoutes]);
          }

          const increORdecreFareBy=(amt)=>{
            let fare = null , seatsArray = [] ,fareJson ={} , fareJsonString ='';

            for(var i=0;i<filteredRoutes.length;i++){
                    if(i == 0){
                        if(isValid(seatGroupIds)){
                            seatsArray=getArrayfromString(seatGroupIds);
                        }
                    }

                    filteredRoutes[i]["fare"] = getFare(filteredRoutes[i]["fare"],amt);
                    let fareJsonObject=JSON.parse(filteredRoutes[i]['fare_json']);
                    seatsArray.forEach((key)=>{
                        fareJson[key] = getFare(fareJsonObject[key],amt);
                    });
                    fareJsonString = JSON.stringify(fareJson);
                    
                    filteredRoutes[i]["fare_json"] = fareJsonString;
                    filteredRoutes[i]["is_fare_edited"] = true;
                    
                }
            setFilteredRoutes([...filteredRoutes]);
            resetModal()
          }

          const increORdecreFareByColumn = (amt, columnKey) => {
            let tempRoutes = [...filteredRoutes];
            tempRoutes.forEach((route, i) => {
              if (columnKey === 'fare') {
                tempRoutes[i]["fare"] = getFare(tempRoutes[i]["fare"], amt);
              } else {
                let fareJsonObject = JSON.parse(tempRoutes[i]['fare_json']);
                fareJsonObject[columnKey] = getFare(fareJsonObject[columnKey], amt);
                tempRoutes[i]['fare_json'] = JSON.stringify(fareJsonObject);
              }
              tempRoutes[i]["is_fare_edited"] = true;
            });
            setFilteredRoutes(tempRoutes);
            resetModal();
          };

          const resetModal=()=>{
            setIsVisible(false);
            setValue(0);
          }

          const copyFirstRowFareToAllRoutes =()=>{
            for(var i=0;i<filteredRoutes.length;i++){
                    filteredRoutes[i]["fare"]=filteredRoutes[0]['fare'];
                    let fareJson = filteredRoutes[0]['fare_json'];
                    filteredRoutes[i]["fare_json"]=fareJson;
                    filteredRoutes[i]["is_fare_edited"]=true;
                }
            setFilteredRoutes([...filteredRoutes]);
          }

        const renderColumnHeader = (columnKey) => {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div>
                        <Button
                            size="small"
                            className="edit-fare-btn-plus-table"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                setBtnType(plusBtn);
                                setActiveColumn(columnKey);
                                setIsVisible(true);
                            }}
                        />
                    </div>
                    <div>
                        <Tooltip placement="topLeft" title={"With Out GST"}>
                            <Text>{columnKey}</Text>
                        </Tooltip>
                    </div>
                    <div>
                        <Button
                            size="small"
                            className="edit-fare-btn-minus-table"
                            icon={<MinusOutlined />}
                            onClick={() => {
                                setBtnType(minusBtn);
                                setActiveColumn(columnKey);
                                setIsVisible(true);
                            }}
                        />
                    </div>
                </div>
            );
        };

        const columns=[
            {
                title: '',
                dataIndex: 'origin',
                key: 'origin',
                render: (text,row) => {
                    return (
                        <div>
                            {row.origin} - {row.destination}
                        </div>
                    )
                }
            }
        ];

        if(supportedFare === 1){
            columns.push({
                title: renderColumnHeader('fare'),
                dataIndex: 'fare',
                key: 'fare',
                render: (text,rowIndex ,viewIndex) => {
                    let dataIndex='fare';
                    let key = rowIndex.id;
                    const index = filteredRoutes.findIndex(item => key === item.id);
                    return renderComponentTable({text,rowIndex ,viewIndex,dataIndex,index});
                }
            });
        }

        if(isValidString(seatGroupIds)){
            let seatsArray=getArrayfromString(seatGroupIds);
            seatsArray.forEach(fareJsonKey => {
                columns.push({
                    title: renderColumnHeader(fareJsonKey),
                    dataIndex:'fare_json',
                    key: 'fare_json',
                    align:'center',
                    render: (text,rowIndex ,viewIndex) => {
                        let dataIndex='fare_json';
                        let key = rowIndex.id;
                        const index = filteredRoutes.findIndex(item => key === item.id);
                        return renderComponentTable({text,rowIndex ,viewIndex,dataIndex,index,fareJsonKey});
                    }
                })
            });
        }

        const renderComponentTable=({text,dataIndex,index,fareJsonKey})=>{
            let fareJsonObject={};
            let asError =false;
            if(!isValid(fareJsonKey)){
                asError = isValidArray(errorHandle)&&isValidArray(errorHandle[index])&&errorHandle[index].indexOf("fare")!=-1
            }else{
                asError = isValidArray(errorHandle)&&isValidArray(errorHandle[index])&&errorHandle[index].indexOf(fareJsonKey)!=-1
            }
            if(isValidString(fareJsonKey)&&isValidString(text)){
              fareJsonObject=JSON.parse(text);
              text=fareJsonObject[fareJsonKey];
            }
                if(text<100){
                    asError =true;
                }else{
                    asError = false;
                }
                
              return {
                props: {
                  className:'',
                },
               children:  <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                                    <InputNumber 
                                            className={asError?"fare-input-error edit-fare-input":"edit-fare-input"}
                                            value={text}
                                            onChange={(value)=>{
                                                // let value = e.target.value;
                                                if(isValid(value) && value.length > 0){
                                                    value = Number(value);
                                                }
                                                if(isValidString(fareJsonKey)){
                                                    fareJsonObject[fareJsonKey]=value;
                                                    filteredRoutes[index][dataIndex]=JSON.stringify(fareJsonObject);
                                                }else{
                                                    filteredRoutes[index][dataIndex]=value;
                                                }
                                                filteredRoutes[index].is_fare_edited=true;
                                                setFilteredRoutes([...filteredRoutes]);
                                                }}
                                    />
                           </div>
              };
            }

            if(tripDynamicPricing && canShowDynamicPricing){
                return (<div className="marginTop marginBottom marginLeft">
                    <Row>
                        <Col>
                            <DynamicPriceBtn 
                                scheduleId={scheduleId}
                                travelDates={[getAPIDateFormat(travelDate)]}
                                tripDynamicPriceEnabled={tripDynamicPricing}
                            />
                        </Col>
                        <Col offset= {4}>
                            <span>
                                <strong>Dynamic Pricing: </strong>
                                    <Switch
                                        checkedChildren="Yes"
                                        unCheckedChildren="No"
                                        defaultChecked={tripDynamicPricing}
                                        onChange= {onChangeDynamicPricing}
                                    />
                            </span>
                        </Col>
                    </Row>
                </div>)
            }else{
                return (
                    <div className="marginLeft tab-block">
                        <ZoomComponent isZoomEnabled={isMobile}> 
                                <div style={{marginTop:'10px'}}>
                                    {showTravelDate?
                                        <div className="fontWeightBold">
                                            Travel Date : {getFormatedDate(travelDate,true,true,true,'.')}
                                        </div>
                                        :
                                        null
                                    }
                                    <OriginDestionationFilter 
                                        origins={origins}
                                        destinations={destinations}
                                        onOriginChange={onOriginChange}
                                        onDestionationChange={onDestionationChange}
                                        origin={originsFiltered}
                                        destination={destinationsFiltered}
                                    />
                                    <Row gutter={[4,4]}>
                                        <Col>
                                            <Checkbox
                                                checked={changeSeatSpecificFare}
                                                onChange={(e)=>setChangeSeatSpecificFare(e.target.checked)}
                                            >
                                                Change seat specific fare
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <div>
                                        <Row className="buttons-block" gutter={[10,12]}>
                                            {showGetPriceButton?
                                                <>
                                                    <Col className="cancel-button-root">
                                                        <Button className="get-fare-button" icon={<CalendarOutlined />} onClick={onGetPriceClick}
                                                            disabled={!isValidArrayWithValues(selectedDates)}>Get Fare</Button>
                                                    </Col>
                                                    <Col className="cancel-button-root">
                                                        <Button className="get-default-fare-button" onClick={()=>{
                                                            fetchViaCitiesDetails(true);
                                                        }} disabled={isValidArrayWithValues(selectedDates)}><LayersIcon style={{marginRight:6,verticalAlign:'-0.2em'}} />Get Default Fare</Button>
                                                    </Col>
                                                    <Col className="cancel-button-root">
                                                        <Button
                                                            className="mark-peak-button"
                                                            icon={<FireOutlined />}
                                                            onClick={()=>handleMarkFareType('PEAK')}
                                                            disabled={!isValidArrayWithValues(selectedDates)}
                                                        >Mark Peak</Button>
                                                    </Col>
                                                    <Col className="cancel-button-root">
                                                        <Button
                                                            className="set-regular-button"
                                                            onClick={()=>handleMarkFareType('REGULAR')}
                                                            disabled={!isValidArrayWithValues(selectedDates)}
                                                        >Set Regular</Button>
                                                    </Col>
                                                </>
                                                :null
                                            }
                                            <Col className="copy-button-root" >
                                                <Button onClick={copyFirstRowFareToAllRoutes}>
                                                        <CopyOutlined 
                                                                size={'large'}
                                                            /> 
                                                        <ArrowDownOutlined 
                                                            size={'large'}
                                                            type="arrow-down" />
                                                </Button>
                                            </Col>
                                            <Col className="copy-button-root" >
                                                <Button onClick={copyFirstFareToAllRoutes}>
                                                    <CopyOutlined 
                                                        size={'large'}
                                                    />
                                                </Button>
                                            </Col>
                                            <Col className="cancel-button-root">
                                                <Button
                                                    className="edit-fare-outline-btn"
                                                    onClick={() => {
                                                        setBtnType(plusBtn);
                                                        setActiveColumn(null);
                                                        setIsVisible(true);
                                                    }}
                                                >
                                                    <PlusOutlined size={'large'} />
                                                </Button>
                                            </Col>
                                            <Col className="cancel-button-root">
                                                <Button
                                                    className="edit-fare-outline-btn"
                                                    onClick={() => {
                                                        setBtnType(minusBtn);
                                                        setActiveColumn(null);
                                                        setIsVisible(true);
                                                    }}
                                                >
                                                    <MinusOutlined size={'large'} />
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Button onClick={handleUpdateFare} className="update-fare-button">
                                                    <CheckOutlined 
                                                        size={'large'}
                                                    />
                                                </Button>
                                            </Col>
                                            {dynamicPricingEnabled&&isValidNumber(tripDynamicPricing)&&canShowDynamicPricing?
                                            <Col offset= {4}>
                                                <span>
                                                    <strong>Dynamic Pricing: </strong>
                                                    <Switch
                                                        checkedChildren="Yes"
                                                        unCheckedChildren="No"
                                                        defaultChecked={tripDynamicPricing}
                                                        onChange= {onChangeDynamicPricing}
                                                    />
                                                </span>
                                            </Col>
                                            :null    
                                            }
                                        </Row>
                                        {isValidArray(filteredRoutes)&&filteredRoutes.length>0?
                                            <div className="edit-fare-table-root">
                                                {showGetPriceButton&&
                                                <>
                                                    <br/>
                                                    <div style={{display:'flex',alignItems:'center',gap:8,marginTop:'8px'}}>
                                                        <Text style={{fontWeight:600}}>Default fare:</Text>
                                                        <div style={FARE_TYPE_SEGMENT_GROUP_STYLE}>
                                                            <button
                                                                type="button"
                                                                onClick={()=>{
                                                                    setDefaultFare(true);
                                                                    setDefaultFareType('REGULAR');
                                                                    fetchViaCitiesDetails(true, 'REGULAR');
                                                                }}
                                                                style={defaultFareType==='PEAK' ? FARE_TYPE_SEGMENT_IDLE_STYLE : FARE_TYPE_SEGMENT_REGULAR_STYLE}
                                                            >
                                                                Regular
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={()=>{
                                                                    setDefaultFare(true);
                                                                    setDefaultFareType('PEAK');
                                                                    fetchViaCitiesDetails(true, 'PEAK');
                                                                }}
                                                                style={defaultFareType==='PEAK' ? FARE_TYPE_SEGMENT_PEAK_STYLE : FARE_TYPE_SEGMENT_IDLE_STYLE}
                                                            >
                                                                <FireOutlined />Peak
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>}
                                                {renderAboveTable && renderAboveTable()}
                                                <Table
                                                    dataSource={filteredRoutes}
                                                    columns={columns}
                                                    pagination={{pageSize:50}}
                                                    className="edit-fare-table"
                                                />
                                            </div>
                                            :null
                                        }
                                    </div>
                                    <Modal
                                    title={
                                        activeColumn
                                            ? (btnType === plusBtn ? `Increase ${activeColumn} fares` : `Decrease ${activeColumn} fares`)
                                            : (btnType === plusBtn ? "Increase all fares" : "Decrease all fares")
                                    }
                                    visible={isVisible}
                                    okText="Apply"
                                    onOk={() => {
                                        if (activeColumn) {
                                            increORdecreFareByColumn(value, activeColumn);
                                        } else {
                                            increORdecreFareBy(value);
                                        }
                                    }}
                                    onCancel={resetModal}
                                    >
                                        <Radio.Group
                                            value={fareUpdateType}
                                            onChange={(e) => setFareUpdateType(e.target.value)}
                                            style={{ marginBottom: '16px' }}
                                        >
                                            <Radio value="amount">Amount</Radio>
                                            <Radio value="percentage">Percentage</Radio>
                                        </Radio.Group>
                                        <br />
                                        <InputNumber
                                            value={value} 
                                            onChange={(data)=>{
                                                setValue(data);
                                            }}
                                        />
                                       {fareUpdateType === 'amount' ? " ₹": " %"}
                                    </Modal>


                                </div>
                                </ZoomComponent>
                    </div>
                )
            }
    }else{
        return null
    }
}


